import privateIdentityApiClient from "@libs/acp/services/identity/privateAxiosInstance";

import type {
	IdentityUnifyPasswordRequestProps,
	IdentityUpdateContactSendCodeRequestProps,
	IdentityUpdateContactVerifyCodeRequestProps,
	IdentityUpdatePasswordRequestProps,
	IdentityUpdateSocialNameRequestProps,
} from "./types";

export const identityUpdateContactSendCode = ({
	type,
	contact,
	flow_type,
}: IdentityUpdateContactSendCodeRequestProps) => {
	return privateIdentityApiClient.post(`/v2/app/update-contact/${type}`, {
		contact,
		...(flow_type ? { flow_type } : {}),
	});
};

export const identityValidateConflictingEmailSendCode = () => {
	return privateIdentityApiClient.post("/v2/app/confirm-email/send-code", {});
};

export const identityValidateConflictingEmailValidateMFACode = ({
	token,
}: IdentityUpdateContactVerifyCodeRequestProps) => {
	return privateIdentityApiClient.post("/v2/app/confirm-email/validate-code", {
		code: token,
	});
};

export const identityUpdateContactVerifyCode = ({
	type,
	token,
}: IdentityUpdateContactVerifyCodeRequestProps) => {
	return privateIdentityApiClient.post(
		`/v2/app/update-contact/${type}/validate`,
		{ token },
	);
};

export const identityUpdatePassword = ({
	current_password,
	new_password,
}: IdentityUpdatePasswordRequestProps) => {
	return privateIdentityApiClient.post("/v2/app/update-password", {
		current_password,
		new_password,
	});
};

export const identityUnifyPassword = ({
	new_password,
}: IdentityUnifyPasswordRequestProps) => {
	return privateIdentityApiClient.post("/v2/app/update-password/cross", {
		new_password,
	});
};

export const identityResubEmail = () => {
	return privateIdentityApiClient.post("/v2/app/email-subscribe", {});
};

export const identityUpdateSocialName = ({
	socialName,
}: IdentityUpdateSocialNameRequestProps) => {
	return privateIdentityApiClient.put("/v2/app/update-social-name", {
		socialName,
	});
};
